var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{directives:[{name:"intersect",rawName:"v-intersect.once",value:(_vm.handleView),expression:"handleView",modifiers:{"once":true}}],staticClass:"d-flex flex-column justify-space-around",style:({
    color: _vm.color,
    backgroundColor: _vm.backgroundColor
  }),attrs:{"rounded":"sm","elevation":"0","flat":"","href":_vm.link},on:{"click":function($event){$event.preventDefault();return _vm.handleLink.apply(null, arguments)}}},[_c('img',{attrs:{"src":_vm.src,"title":'logo' + _vm.proposal.descr}}),_c('v-card-text',{staticClass:"pre-slide-text",style:({
      color: _vm.color
    }),domProps:{"innerHTML":_vm._s(_vm.proposal.content)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }